// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import config from './configuration'
import i18n from './i18n/index'
import vuex from 'vuex'
import VueResource from 'vue-resource'
import '@/mixins/helper'
import '@/mixins/console'
import '@/mixins/export'
import { accessTokenValid, refreshTokenValid, logout } from '@/router/auth'
import { getRefreshToken, getAccessToken, setAccessToken } from '@/utils/cookie'
import { endpointRequireToken } from './utils/endpoints'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import 'vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap4.scss'
import VueTabulator from 'vue-tabulator'

Vue.use(Vuetify)
Vue.use(config)
Vue.use(vuex)
Vue.use(VueResource)
Vue.use(VueTabulator)

Vue.config.productionTip = false
Vue.config.debug = false
// Vue.config.devtools = false
if (window.location.origin.toUpperCase().includes(`.${Vue.$config.service_domain}`.toUpperCase())) {
  Vue.http.options.root = Vue.$config.api_root
} else {
  Vue.http.options.root = Vue.$config.api_root_internal
}

const AUTHORIZATION = 'Authorization'
const REFRESH_TOKEN = 'REFRESH_TOKEN'

// TODO extract into separate file
Vue.http.interceptors.push(function (request, next) {
  const isTokenRequired = Vue.http.headers.common[REFRESH_TOKEN] !== 'IN_PROGRESS' && endpointRequireToken(request.url)
  Vue.http.headers.common['Content-Type'] = 'application/json'
  if (isTokenRequired) {
    Vue.http.headers.common[AUTHORIZATION] = 'Bearer ' + getAccessToken()
    if (!accessTokenValid()) {
      handleInvalidToken(request, next)
      return
    }
  }
  // continue to next interceptor
  next()
})

// #region functions
function handleInvalidToken (request, next) {
  const isDevelopmentEnvironment = process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'pmiproduction'
  if (isDevelopmentEnvironment) { console.log('Access token expired - attempting to refresh') }
  if (!refreshTokenValid()) {
    if (isDevelopmentEnvironment) { console.log('Refresh token no longer valid') }
    logout()
    this.notifyError(i18n.t('errors.token.refreshTokenExpired'))
  } else {
    // REFRESH TOKEN
    next(() => {
      Vue.http.headers.common[REFRESH_TOKEN] = 'IN_PROGRESS'
      const refreshTokenUrl = Vue.$apiConfig.loginRefresh
      Vue.http.headers.common[AUTHORIZATION] = 'Bearer ' + getRefreshToken()
      return Vue.http.get(refreshTokenUrl)
        .then(response => {
          if (isDevelopmentEnvironment) { console.log('Access token refreshed successfully') }
          setAccessToken(response.data.payload.accessToken)
          Vue.http.headers.common[AUTHORIZATION] = 'Bearer ' + response.data.payload.accessToken
          Vue.http.headers.common[REFRESH_TOKEN] = 'DONE'
          request.headers.set('Authorization', 'Bearer ' + response.data.payload.accessToken)
          return Vue.http(request).then(data => {
            return data
          })
        }, error => {
          Vue.http.headers.common[REFRESH_TOKEN] = 'DONE'
          if (isDevelopmentEnvironment) { console.log('Failed to obtain new access token after refresh: ' + error) }
          logout()
          let errorMessage = ''
          if (error.status === 0) {
            errorMessage = i18n.t('apiStatusCodes.0')
          } else {
            errorMessage = i18n.t('errors.token.failedToRefreshToken')
          }
          this.notifyError(errorMessage)
        })
    })
  }
}

new Vue({
  vuetify: new Vuetify(
    {
      icons: {
        iconfont: 'mdi'
      }
    }
  ),
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
